import { render, staticRenderFns } from "./MatchCard.vue?vue&type=template&id=0c2711d9&scoped=true"
import script from "./MatchCard.vue?vue&type=script&lang=js"
export * from "./MatchCard.vue?vue&type=script&lang=js"
import style0 from "./MatchCard.vue?vue&type=style&index=0&id=0c2711d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2711d9",
  null
  
)

export default component.exports